define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/datasheet/Preferences",
	"csi/datasheet/Widget",
	"csi/locale",
	"csi/state",
	"csi/xml",
	"ProductSpec/SizeChart/CustomViewSizeChartOptions",
	"ProductSpec/SizeChart/SizeChartReviewDataSheetCustomViewOptionsStore",
	"ProductSpec/SizeChart/SizeChartReviewDataSheetOptionsTab",
], function(declare, _, Preferences, DataSheetWidget, locale, state, xml, {SizeChartReviewPrintOldReviewOptions}, SizeChartReviewDataSheetCustomViewOptionsStore, SizeChartReviewDataSheetOptionsTab) {

	var PRINT_REVIEWS_DEFAULT = "0";
	var PRINT_REVIEWS_ALL = "-1";

	var _Preferences = declare(Preferences, {
		constructor: function() {
			this.addCustomOption("reviewPrintOldReviews", PRINT_REVIEWS_DEFAULT);
			this.addCustomOption("reviewPrintAllSuppliers", false);
			this.addCustomOption("reviewPrintEvaluationPerSize", false, false, "SizeChartPrintReviewSizes");
		}
	});

	return declare(DataSheetWidget, {
		customViewOptionsComponent: SizeChartReviewDataSheetOptionsTab,
		customViewOptionsStore: SizeChartReviewDataSheetCustomViewOptionsStore,
		prefClass: _Preferences,

		// Boolean: indicate if evaluation view should be printed one size at a time
		//reviewPrintEvaluationPerSize: false,

		// Boolean: indicates number of past sample reviews to show per size; only available if reviewPrintEvaluationPerSize is true
		//reviewPrintAllSuppliers: false,

		// Number: indicates number of past sample reviews to show per size; only available if reviewPrintEvaluationPerSize is true
		reviewPrintOldReviews: PRINT_REVIEWS_DEFAULT,

		_getReviewsPerSize: function(/*String*/urlSize) {
			// summary: return reviews available for current size
			if (this.reviewPrintOldReviews == PRINT_REVIEWS_DEFAULT) {
				return null;
			}

			// function relies on nodes only available in print mode (see _getRootRequest)
			console.assert(!!state.get("print"));

			var nPrint = Number(this.reviewPrintOldReviews);
			var cache = this.cacheView;
			var size = cache.getNode(urlSize);
			var reviews = size.ReviewHistory || [];

			// filter out reviews from suppliers other than the current one
			if (!this.reviewPrintAllSuppliers) {
				var urlSupplier = cache.getNode(size.__Parent__).ReviewSupplier;

				reviews = _.filter(reviews, function(url) {
					return cache.getNode(url).ReviewSupplier == urlSupplier;
				});
			}

			// trim the list based on the number desired
			if ((this.reviewPrintOldReviews != PRINT_REVIEWS_ALL) && (reviews.length > nPrint)) {
				reviews = _.rest(reviews, reviews.length - nPrint);
			}

			return reviews;
		},

		_getRootRequest: function(/*Node*/node) {
			// summary: add review sizes as dependency path when printing just in case
			var req = this.inherited(arguments);

			if (state.get("print")) {
				var p = xml.path(xml.ATTR_PARENT, "ReviewSizes");

				if (this.reviewPrintEvaluationPerSize && !this.reviewPrintAllSuppliers) {
					p = xml.path(p, "ReviewHistory");
				}

				req.addDependencyPaths([p]);

			}

			return req;
		},

		_processKey: function(/*Context*/ctx, /*String*/key, /*Object*/def, /*DOMNode*/domNode) {
			// summary: render definition in context for element
			if (ctx.bPrint && this.reviewPrintEvaluationPerSize && (key == "Evaluation")) {
				var sizes = ctx.getParent().ReviewSizes;
				var params = _.map(sizes, function(url) {
					return {
						columnNodeUrls: [url],
						reviewUrls: this._getReviewsPerSize(url),
						secondaryViewId: url
					};
				}, this);

				var labels = _.map(ctx.cache.getNodes(sizes), function(size) {
					return locale.typeView("SizeChartRevision", def.m_id) + " - " + locale.getNodeName(size, ctx.cache);
				});

				this._processViewRefForEach(ctx, def, domNode, params, labels);
				return null;
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Return all the dropdown options for Size chart options section
		 */
		getCustomViewDropDownOptions() {
			const options = this.inherited(arguments);

			return {
				...options,
				sizeChartReviewPrintOldReviewOptions: SizeChartReviewPrintOldReviewOptions,
			};
		}
	});
});
